/**
 * Service responsible for communicating with Adobe Experience Platform (Adobe Campaign).
 */
export abstract class AdobeExperiencePlatformService {
    abstract trackAction(action: string): void;
}